import { useLocation } from 'react-router-dom';

export default function useRestaurantControls(restaurant) {
  const location = useLocation();
  const isPreviewMode = location.pathname.indexOf('preview') > -1;
  const isShowControls = isPreviewMode ? false : restaurant?.is_owner;

  return { isPreviewMode, isShowControls };
}
